import React from 'react'
import { SaleAnalyticsOverviewProps } from './interface'

export function withSaleAnalyticsOverview(
  Component: React.FC<SaleAnalyticsOverviewProps>
) {
  function WithSaleAnalyticsOverview(props: SaleAnalyticsOverviewProps) {
    return <Component {...props} />
  }
  return WithSaleAnalyticsOverview
}
